import { createApi } from '@reduxjs/toolkit/query/react';
import { API_INVENTORY_URL } from '@/utils';
import { createBaseQueryWithReauth } from '@/services';
import { OfficeApi, OfficesFilter } from '../models';
import { PaginatedRequest, PaginatedResponse } from '@/types';

const officesService = createApi({
  reducerPath: 'officesService',
  baseQuery: createBaseQueryWithReauth(`${API_INVENTORY_URL}/offices`),
  tagTypes: ['Offices'],
  endpoints: (builder) => ({
    getOffices: builder.query<
      PaginatedResponse<OfficeApi>,
      { filters?: OfficesFilter; paginated: PaginatedRequest }
    >({
      query: ({ filters, paginated }) => ({
        url: '',
        params: {
          ...(filters || {}),
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
          populate: 'city',
        },
      }),
      providesTags: ['Offices'],
    }),
    createOffice: builder.mutation({
      query: (body) => ({
        url: '',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Offices'],
    }),
    updateOffice: builder.mutation({
      query: ({ id, body }) => ({
        url: `/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Offices'],
    }),
  }),
});

export default officesService;
export const {
  useGetOfficesQuery,
  useCreateOfficeMutation,
  useUpdateOfficeMutation,
} = officesService;
